/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Faq_Ideas_QuestionInputs */

const en_landing_faq_ideas_question = /** @type {(inputs: Landing_Faq_Ideas_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does Inginuiti generate its own trade ideas or interpretations?`)
};

/**
* | output |
* | --- |
* | "Does Inginuiti generate its own trade ideas or interpretations?" |
*
* @param {Landing_Faq_Ideas_QuestionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_faq_ideas_question = /** @type {((inputs?: Landing_Faq_Ideas_QuestionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Faq_Ideas_QuestionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_faq_ideas_question(inputs)
});